import { defFnOp, defOp } from "./compile/emit.js";
import { ARGS_VV, FN2 } from "./compile/templates.js";
export const [atan, atan2, atan3, atan4] = defFnOp("Math.atan");
export const [atan_2, atan_22, atan_23, atan_24] = defOp(FN2("Math.atan2"), ARGS_VV);
